/**
 * Removes surrounding whitespace from a code typed for a device: its inventory number or
 * QR code.
 *
 * The whitespace is never part of the code, and IRES Project's scanner compares the
 * stored value exactly: a HyDry box stored as `"FU-0010-0040 "` was not found by its
 * scan, which then assigned SanTec's deleted generic device of the same number instead
 * (2026-10-29). `null` and `undefined` pass through, so an absent code stays absent.
 */
export function trimDeviceCode<T extends string | null | undefined>(code: T): T {
  return (typeof code === "string" ? code.trim() : code) as T;
}
